// extracted by mini-css-extract-plugin
module.exports = {"PersonalInfo":"styles_PersonalInfo__LI3PP"};